// extracted by css-extract-rspack-plugin
export default {"root":"ni4ppy"};